<template>
  <div ref="containerRef" class="full-width-image">
    <!-- Imagen de fondo (no alterada) -->
    <img
      ref="imagenRef"
      src="@/assets/carru5_ed1.webp"
      alt="Fondo elegante"
      class="main-image"
    />

    <!-- Cortina para reveal -->
    <div ref="revealRef" class="reveal" aria-hidden="true"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'FullWidthImage',
  setup() {
    const containerRef = ref(null)
    const revealRef = ref(null)

    const animate = () => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      // Fade + elevación del contenedor
      tl.from(containerRef.value, {
        y: 40,
        opacity: 0,
        duration: 1
      })

      // Cortina blanca que destapa la imagen
      gsap.set(revealRef.value, { transformOrigin: 'left center', scaleX: 1 })
      tl.to(revealRef.value, {
        scaleX: 0,
        duration: 1.2
      }, '-=0.6')
    }

    onMounted(() => {
      const observer = new IntersectionObserver(([entry], obs) => {
        if (entry.isIntersecting) {
          animate()
          obs.unobserve(entry.target)
        }
      }, { threshold: 0.25 })

      if (containerRef.value) observer.observe(containerRef.value)
    })

    return {
      containerRef,
      revealRef
    }
  }
}
</script>

<style scoped>
.full-width-image {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.main-image {
  width: 100%;
  height: auto;
  display: block;
  transform-origin: center;
}

/* Cortina de reveal elegante */
.reveal {
  position: absolute;
  inset: 0;
  background: #ffffff;
  pointer-events: none;
}
</style>
